import React from "react";

const CustomLabel = ({ x, y, width, height, value, index, data }) => {
    return (
        <text
            x={x + width / 2 - 25}
            y={height > 0 ? y - 10 : y - 10 + height}
            fill="black"
            textAnchor="middle"
            fontSize={14}
            className=""
        >
            {`$${value.toFixed(2).toLocaleString()}`}
        </text>
    );
};

export default CustomLabel;
